/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { DataSourceLoadOptionsBase } from '../models/data-source-load-options-base';
import { LoadResult } from '../models/load-result';
import { TypeAccesPersonneMoraleDto } from '../models/type-acces-personne-morale-dto';


/**
 * Fonctions de gestion des types d'accès des personnes morales
 */
@Injectable({
  providedIn: 'root',
})
export class TypesAccesPersonnesMoralesService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation typeAccesPersonneMoraleGetList
   */
  static readonly TypeAccesPersonneMoraleGetListPath = '/api/types-acces-personnes-morales/list';

  /**
   * Renvoie la liste des types d'accès des personnes morales.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeAccesPersonneMoraleGetList()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeAccesPersonneMoraleGetList$Response(params?: {
  }): Observable<StrictHttpResponse<Array<TypeAccesPersonneMoraleDto>>> {

    const rb = new RequestBuilder(this.rootUrl, TypesAccesPersonnesMoralesService.TypeAccesPersonneMoraleGetListPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TypeAccesPersonneMoraleDto>>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'accès des personnes morales.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeAccesPersonneMoraleGetList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeAccesPersonneMoraleGetList(params?: {
  }): Observable<Array<TypeAccesPersonneMoraleDto>> {

    return this.typeAccesPersonneMoraleGetList$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TypeAccesPersonneMoraleDto>>) => r.body as Array<TypeAccesPersonneMoraleDto>)
    );
  }

  /**
   * Path part for operation typeAccesPersonneMoraleLoadList
   */
  static readonly TypeAccesPersonneMoraleLoadListPath = '/api/types-acces-personnes-morales/load-list';

  /**
   * Renvoie la liste des types d'accès des personnes morales (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeAccesPersonneMoraleLoadList()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeAccesPersonneMoraleLoadList$Response(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<StrictHttpResponse<LoadResult>> {

    const rb = new RequestBuilder(this.rootUrl, TypesAccesPersonnesMoralesService.TypeAccesPersonneMoraleLoadListPath, 'post');
    if (params) {
      rb.query('parcId', params.parcId, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<LoadResult>;
      })
    );
  }

  /**
   * Renvoie la liste des types d'accès des personnes morales (avec support pour groupement, filtrage, pagination et tri).
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeAccesPersonneMoraleLoadList$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeAccesPersonneMoraleLoadList(params: {

    /**
     * Identifiant du parc
     */
    parcId?: number;

    /**
     * Paramètres de groupement, filtrage, pagination et tri
     */
    body: DataSourceLoadOptionsBase
  }): Observable<LoadResult> {

    return this.typeAccesPersonneMoraleLoadList$Response(params).pipe(
      map((r: StrictHttpResponse<LoadResult>) => r.body as LoadResult)
    );
  }

  /**
   * Path part for operation typeAccesPersonneMoraleGet
   */
  static readonly TypeAccesPersonneMoraleGetPath = '/api/types-acces-personnes-morales/{id}';

  /**
   * Renvoie le type d'accès spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeAccesPersonneMoraleGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeAccesPersonneMoraleGet$Response(params: {

    /**
     * Identifiant du type d&#x27;accès
     */
    id: number;
  }): Observable<StrictHttpResponse<TypeAccesPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesAccesPersonnesMoralesService.TypeAccesPersonneMoraleGetPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeAccesPersonneMoraleDto>;
      })
    );
  }

  /**
   * Renvoie le type d'accès spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeAccesPersonneMoraleGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeAccesPersonneMoraleGet(params: {

    /**
     * Identifiant du type d&#x27;accès
     */
    id: number;
  }): Observable<TypeAccesPersonneMoraleDto> {

    return this.typeAccesPersonneMoraleGet$Response(params).pipe(
      map((r: StrictHttpResponse<TypeAccesPersonneMoraleDto>) => r.body as TypeAccesPersonneMoraleDto)
    );
  }

  /**
   * Path part for operation typeAccesPersonneMoralePut
   */
  static readonly TypeAccesPersonneMoralePutPath = '/api/types-acces-personnes-morales/{id}';

  /**
   * Met à jour le type d'accès spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeAccesPersonneMoralePut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeAccesPersonneMoralePut$Response(params: {

    /**
     * Identifiant du type d&#x27;accès à mettre à jour
     */
    id: number;

    /**
     * Type d'accès
     */
    body: TypeAccesPersonneMoraleDto
  }): Observable<StrictHttpResponse<TypeAccesPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesAccesPersonnesMoralesService.TypeAccesPersonneMoralePutPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeAccesPersonneMoraleDto>;
      })
    );
  }

  /**
   * Met à jour le type d'accès spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeAccesPersonneMoralePut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeAccesPersonneMoralePut(params: {

    /**
     * Identifiant du type d&#x27;accès à mettre à jour
     */
    id: number;

    /**
     * Type d'accès
     */
    body: TypeAccesPersonneMoraleDto
  }): Observable<TypeAccesPersonneMoraleDto> {

    return this.typeAccesPersonneMoralePut$Response(params).pipe(
      map((r: StrictHttpResponse<TypeAccesPersonneMoraleDto>) => r.body as TypeAccesPersonneMoraleDto)
    );
  }

  /**
   * Path part for operation typeAccesPersonneMoraleDelete
   */
  static readonly TypeAccesPersonneMoraleDeletePath = '/api/types-acces-personnes-morales/{id}';

  /**
   * Supprime le type d'accès spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeAccesPersonneMoraleDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeAccesPersonneMoraleDelete$Response(params: {

    /**
     * Identifiant du type d&#x27;accès à supprimer
     */
    id: number;
  }): Observable<StrictHttpResponse<number>> {

    const rb = new RequestBuilder(this.rootUrl, TypesAccesPersonnesMoralesService.TypeAccesPersonneMoraleDeletePath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: parseFloat(String((r as HttpResponse<any>).body)) }) as StrictHttpResponse<number>;
      })
    );
  }

  /**
   * Supprime le type d'accès spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeAccesPersonneMoraleDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  typeAccesPersonneMoraleDelete(params: {

    /**
     * Identifiant du type d&#x27;accès à supprimer
     */
    id: number;
  }): Observable<number> {

    return this.typeAccesPersonneMoraleDelete$Response(params).pipe(
      map((r: StrictHttpResponse<number>) => r.body as number)
    );
  }

  /**
   * Path part for operation typeAccesPersonneMoralePost
   */
  static readonly TypeAccesPersonneMoralePostPath = '/api/types-acces-personnes-morales';

  /**
   * Crée le type d'accès spécifié.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `typeAccesPersonneMoralePost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeAccesPersonneMoralePost$Response(params: {

    /**
     * Type d'accès
     */
    body: TypeAccesPersonneMoraleDto
  }): Observable<StrictHttpResponse<TypeAccesPersonneMoraleDto>> {

    const rb = new RequestBuilder(this.rootUrl, TypesAccesPersonnesMoralesService.TypeAccesPersonneMoralePostPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TypeAccesPersonneMoraleDto>;
      })
    );
  }

  /**
   * Crée le type d'accès spécifié.
   *
   *
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `typeAccesPersonneMoralePost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  typeAccesPersonneMoralePost(params: {

    /**
     * Type d'accès
     */
    body: TypeAccesPersonneMoraleDto
  }): Observable<TypeAccesPersonneMoraleDto> {

    return this.typeAccesPersonneMoralePost$Response(params).pipe(
      map((r: StrictHttpResponse<TypeAccesPersonneMoraleDto>) => r.body as TypeAccesPersonneMoraleDto)
    );
  }

}
